const IcoOrangeInfo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M12.917 17H11.0791V9.89844H12.917V17Z" fill="#FF4400" />
    <path
      d="M12 7C12.1784 7 12.344 7.04441 12.4961 7.13379C12.651 7.22316 12.7737 7.34417 12.8643 7.49512C12.9547 7.64285 12.9999 7.80592 13 7.98438C13 8.16312 12.9549 8.32848 12.8643 8.47949C12.7736 8.63049 12.652 8.75047 12.5 8.83984C12.348 8.92614 12.1813 8.96973 12 8.96973C11.8187 8.96973 11.652 8.92614 11.5 8.83984C11.348 8.75047 11.2264 8.63049 11.1357 8.47949C11.0451 8.32848 11 8.16312 11 7.98438C11.0001 7.80592 11.0453 7.64285 11.1357 7.49512C11.2264 7.34409 11.348 7.22317 11.5 7.13379C11.6549 7.04445 11.8217 7 12 7Z"
      fill="#FF4400"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5Z"
      fill="#FF4400"
    />
  </svg>
);

export default IcoOrangeInfo;
